/**
 * Created by AlexanderC on 6/20/15.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidJoiSchemaException = undefined;

var _Exception2 = require('./Exception');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let InvalidJoiSchemaException = exports.InvalidJoiSchemaException = function (_Exception) {
  _inherits(InvalidJoiSchemaException, _Exception);

  /**
   * @param {String} schemaName
   */
  function InvalidJoiSchemaException(schemaName) {
    _classCallCheck(this, InvalidJoiSchemaException);

    return _possibleConstructorReturn(this, (InvalidJoiSchemaException.__proto__ || Object.getPrototypeOf(InvalidJoiSchemaException)).call(this, `Invalid validation schema ${schemaName}. Object must be a Joi instance!`));
  }

  return InvalidJoiSchemaException;
}(_Exception2.Exception);


//////////////////
// WEBPACK FOOTER
// ../~/deep-validation/lib.compiled/Exception/InvalidJoiSchemaException.js
// module id = 456
// module chunks = 0